export default __webpack_public_path__ + "static/media/icon-location.c062d350.svg";